import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const dialogAttributes: DynamicDialogConfig = {
  closeOnEscape: false,
  baseZIndex: 0,
  autoZIndex: true,
  dismissableMask: false,
  rtl: false,
  transitionOptions: '200ms cubic-bezier(0.25, 0.8, 0.25, 1)',
  closable: true,
  showHeader: true,
  modal: true,
  resizable: true,
  draggable: true,
  keepInViewport: true,
};
